<template>
  <v-dialog :value="isOpen" persistent scrollable>
    <v-card>
      <v-card-title class="justify-end">
        <v-btn icon flat left @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <DataTable
          :loading="isLoading"
          :items="items"
          :total="total"
          :pagination.sync="pagination"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import beaconApi from '@/api/beacon'
import { handleApiError } from '@/api/util'
import DataTable from '../Customer/DataTable'

export default {
  components: {
    DataTable
  },
  props: {
    beaconId: {
      type: String,
      default: undefined
    },
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isOpen: false,
      isLoading: false,
      items: [],
      total: 0,
      pagination: {
        rowsPerPage: 10
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    pagination() {
      this.fetch()
    }
  },
  mounted() {
    this.isOpen = true
  },
  methods: {
    async fetch() {
      try {
        this.isLoading = true

        const response = await this.getData()

        if (response.status === 200) {
          this.items = response.data.data
          this.total = response.data.total
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.isLoading = false
      }
    },
    getData() {
      const { page, rowsPerPage } = this.pagination
      const { beacon_conversation, date_from, date_to } = this.filters

      return beaconApi.getAnalyticsCustomerTransaction({
        config: {
          pageid: this.selectedBot.pageid,
          data: {
            beaconId: this.beaconId,
            beacon_conversation,
            dateFrom: date_from,
            dateTo: date_to,
            offset: (page - 1) * rowsPerPage,
            limit: rowsPerPage,
            excluded_conversation: '{default}'
          }
        }
      })
    },
    close() {
      this.isOpen = false

      setTimeout(() => {
        this.$emit('close')
      }, 300)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/AnalyticsV2/Dashboard/CustomerListDialog.vue